import * as allowedFeaturesConstants from './allowedFeaturesConstants';

// Object.assign is not yet fully supported in all browsers, so we fallback to a polyfill
const assign = Object.assign || require('object.assign');

const initialState = {
    isAllowedFeaturesFetching : false,
    isAllowedFeaturesFetched : false,
    isAllowedFeaturesFailed : false,
    allowedFeatures :null
}

export default function allowedFeaturesReducer(state = initialState, action){

    switch(action.type) {

        case allowedFeaturesConstants.FETCH_ALLOWED_FEATURES_REQUEST:
            return assign({}, state, {
                isAllowedFeaturesFetching : true,
                isAllowedFeaturesFetched : false,
                isAllowedFeaturesFailed : false
            });
            break;

        case allowedFeaturesConstants.FETCH_ALLOWED_FEATURES_SUCCESS:
            return assign({}, state, {
                isAllowedFeaturesFetching : false,
                isAllowedFeaturesFetched : true,
                isAllowedFeaturesFailed : false,
                allowedFeatures : action.newState.result.allowedFeatures
            });
            break;

        case allowedFeaturesConstants.FETCH_ALLOWED_FEATURES_FAILURE:
            localStorage.setItem("allowedFeatures", null);
            return assign({}, state, {
                isAllowedFeaturesFetching : false,
                isAllowedFeaturesFetched : false,
                isAllowedFeaturesFailed : true,
                allowedFeatures : null

            });
            break;
        
        default :
            return state;

    }

}